import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image62 from "../../../../assets/images/Blog64/image62.png";
import image68 from "../../../../assets/images/Blog64/image68.png";
import image19 from "../../../../assets/images/Blog64/image19.png";
import image23 from "../../../../assets/images/Blog64/image23.png";
import image18 from "../../../../assets/images/Blog64/image18.png";
import image21 from "../../../../assets/images/Blog64/image21.png";
import image10 from "../../../../assets/images/Blog64/image10.png";
import image12 from "../../../../assets/images/Blog64/image12.png";
import image9 from "../../../../assets/images/Blog64/image9.png";
import image82 from "../../../../assets/images/Blog64/image82.png";
import image85 from "../../../../assets/images/Blog64/image85.png";
import image100 from "../../../../assets/images/Blog64/image100.png";
import image28 from "../../../../assets/images/Blog64/image28.png";
import image37 from "../../../../assets/images/Blog64/image37.png";
import image53 from "../../../../assets/images/Blog64/image53.png";
import image58 from "../../../../assets/images/Blog64/image58.png";
import image59 from "../../../../assets/images/Blog64/image59.png";
import image60 from "../../../../assets/images/Blog64/image60.png";
import image54 from "../../../../assets/images/Blog64/image54.png";
import image115 from "../../../../assets/images/Blog64/image115.png";
import image116 from "../../../../assets/images/Blog64/image116.png";
import image44 from "../../../../assets/images/Blog64/image44.png";
import image114 from "../../../../assets/images/Blog64/image114.png";

const Blog64 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – April 13th, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Stabilising Uncertainty, Resilient Structure Beneath Softening Growth</p>
        <p>
          Markets are beginning to adjust to a more defined risk environment, where uncertainty has not disappeared, but has become more measurable. The shift from unknown outcomes to{" "}
          <span className="highlightedText">priced risk</span> is allowing markets to stabilise, even as headlines continue to dominate the narrative.
        </p>
        <p>
          Liquidity remains supportive, and indices continue to hold, but participation is not broad-based conviction. Beneath the surface, growth is softening, and sentiment remains cautious,
          creating a market that is <span className="highlightedText">functioning through uncertainty rather than resolving it.</span>{" "}
        </p>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Resilience Holding Despite Macro Friction</p>
              <p>
                Equity markets continue to show resilience, with broader participation beginning to improve after a period of narrow leadership. The structure suggests that while conviction is not
                overwhelming, <span className="highlightedText"> flows are gradually returning,</span> particularly as uncertainty becomes more defined.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image62}
                    alt="SPX EW breakout signals breadth to rally"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image62)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                The key driver remains the interaction between <span className="highlightedText">macro uncertainty and positioning.</span> As uncertainty stabilises, even without fully resolving, it
                reduces the need for elevated risk premia. This has allowed markets to hold levels despite ongoing concerns around inflation, growth, and geopolitics.
              </p>
              <p>
                At the same time, earnings expectations remain intact, and there is no clear evidence yet of a meaningful deterioration in forward projections. This continues to act as a stabilising
                anchor for equities.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image68}
                    alt="no growth downside in the numbers yet"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image68)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Inflation Contained, Growth Losing Momentum</p>
              <p>The macro backdrop remains finely balanced.</p>
              <p>
                Inflation data continues to show limited pass-through into core measures. Price pressures are primarily concentrated in goods, while services and housing remain relatively muted. Core
                inflation is elevated, but not accelerating in a way that forces immediate policy response.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image19}
                    alt="PCE trends"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image19)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt="core inflation elevated already"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>At the same time, growth is beginning to soften. Consumer spending is weakening, and income trends are slipping, with increasing reliance on transfers rather than organic demand.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt="US spending details"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt="US spending funded by transfers"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Globally, the divergence remains clear. While the US continues to show resilience, Europe is flatlining, with business activity stagnating and momentum fading across major economies.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt="EZ PMI flat"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image12}
                    alt="German business activity falling fast"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image12)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>Policy remains caught between these opposing forces. Central banks are navigating dual-sided risks, with neither inflation nor growth providing a clear directional signal.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt="Fed split risks down the middle"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Supportive, but Increasingly Fragile</p>
              <p>Market structure remains intact, but there are signs that momentum is becoming more dependent on flows than conviction.</p>
              <p>
                Breadth has improved, and key indices are holding important levels, suggesting that <span className="highlightedText">underlying demand remains present.</span> However, this demand
                appears reactive rather than aggressive, with positioning still relatively light.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image82}
                    alt="momentum seeing inflows"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image82)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Sentiment indicators show a shift away from extreme bearishness, with bears reducing exposure and insiders increasing activity. This supports the view that the market is transitioning
                from defensive positioning toward a more neutral stance.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image85}
                    alt="insider buying alive and well"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image85)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                At the same time, volatility measures are easing, and correlations are declining, both of which are typically supportive of equity markets. However, this also introduces a risk of
                complacency if macro conditions deteriorate.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image100}
                    alt="SPX correlation dropping bullishly fast"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image100)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The overall setup suggests a market that is <span className="highlightedText"> supported, but not without fragility, </span> particularly if macro data begins to weaken further.
              </p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: From Volatility to Stabilisation</p>
              <p>The past week saw a transition from headline-driven volatility toward a more stable footing, as macro data and geopolitical developments began to provide clearer direction.</p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br />
                    Inflation data surprised to the downside, with CPI missing expectations and core measures remaining stable. Growth indicators, however, showed early signs of slowing, particularly
                    in consumption and income dynamics.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image28}
                        alt="US CPI headline"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image28)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br />
                    There are indications that deflationary pressures may be easing, with price dynamics stabilising after a prolonged period of weakness and policy support helping sentiment at the
                    margin.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image37}
                        alt="Chna sneaking in a deflation escape"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg("image37")}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br />
                    Earnings season is beginning, with focus shifting toward forward guidance, energy impacts, and the effect of rising input costs on margins and outlook expectations.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities:</span>
                    <br />
                    Commodities continue to show strength, with broader indices pushing higher and positioning suggesting continued interest as a macro hedge amid inflation uncertainty.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image53}
                        alt="BB Commods at resistance"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image53)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image58}
                        alt=" Agricultural price woes ahead buy early"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image58)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span>
                    <br />
                    Crypto markets are testing key resistance levels, with flows turning positive after a period of weakness and inflows beginning to pick up again.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image59}
                        alt="BTC testing downtrend resistanc"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image59)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image60}
                        alt="weekly flows positive for Crypto"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image60)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br />
                    Oil remains at a critical technical juncture, requiring a higher high to confirm strength, while failure to do so opens the risk of downside and potential trend weakness.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image54}
                        alt="WTI needs a new HHs"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image54)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                The week is driven by a heavy macro calendar alongside the start of earnings season, with a focus on inflation signals, growth data, and China activity. Markets will be reacting
                through the lens of rates, commodities, and positioning, with data likely shaping expectations around growth resilience and inflation pass-through.
              </p>

              <p className="highlightedText">Monday, April 13</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> New Loans, M2 Money Supply, Loan Growth
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Existing Home Sales (MoM, headline)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> Building Permits
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> US:</span> 3-month and 6-month bill auctions
                  </p>
                </li>
                <li className="themesPointer">
                  <p>IMF Meetings</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, April 14</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Trade Balance, Exports and Imports
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Australia:</span> Consumer Sentiment, Business Confidence
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Industrial Production, Capacity Utilisation
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Spain:</span> CPI, Core CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> PPI (MoM, YoY) and Core PPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Small Business Optimism
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> API crude oil inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>IEA Monthly Report</p>
                </li>
                <li className="themesPointer">
                  <p>BoE Governor Bailey speaks</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, April 15</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Korea:</span> Trade Data (Exports, Imports, Balance)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">France:</span> CPI, HICP
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">EU:</span> Industrial Production
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">India:</span> Trade Balance, Exports and Imports
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Empire Manufacturing Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Import and Export Prices
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Mortgage Data (Applications, Rates)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Crude Oil Inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Beige Book
                  </p>
                </li>
                <li className="themesPointer">
                  <p>IMF Meetings</p>
                </li>
                <li className="themesPointer">
                  <p>BoE Governor Bailey speaks</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, April 16</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> GDP (QoQ, YoY), Industrial Production, Retail Sales, Unemployment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> GDP, Industrial and Manufacturing Production, Trade Balance
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">EU:</span> CPI, Core CPI, HICP
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Switzerland:</span> PPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Initial Jobless Claims, Continuing Claims
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Philadelphia Fed Index (Prices, Employment, New Orders)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Industrial Production, Capacity Utilisation
                  </p>
                </li>
                <li className="themesPointer">
                  <p>ECB Monetary Policy Account</p>
                </li>
                <li className="themesPointer">
                  <p>SNB Policy Assessment</p>
                </li>
                <li className="themesPointer">
                  <p>FOMC Member Williams speaks</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, April 17</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">EU:</span> Trade Balance, Current Account
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Italy:</span> Trade Balance
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">India:</span> Bank Loan Growth, FX Reserves
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> Housing Starts, Foreign Securities Purchases
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> FOMC Member Barkin speaks
                  </p>
                </li>
                <li className="themesPointer">
                  <p>IMF Meetings</p>
                </li>
              </ul>

              <div
                className="imageWrapperCont"
                style={{marginTop: "22px"}}
              >
                <div className="relatedImg">
                  <img
                    src={image115}
                    alt=" Banks earnings next week.png)
"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image115)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image116}
                    alt="EW130426"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image116)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Positioning Rebuild Meets Macro Uncertainty</p>
              <p>
                Markets are transitioning into a phase where uncertainty is stabilising, but not resolved, and positioning is beginning to rebuild against that backdrop. Risk is becoming more
                measurable, allowing pullbacks to hold.
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br />
                    Equity markets remain supported by stable earnings expectations and improving breadth, with equal-weight indices holding key levels. Upside depends on earnings holding and flows
                    continuing to rebuild. Systematic flows are now positive unless VIX holds above 30.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span>
                    <br />
                    Precious metals remain supported by macro uncertainty and softer dollar dynamics, with lower rate expectations and EM pressure easing. Bonds and rates remain the key short-term
                    driver.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br />
                    Crypto is seeing improving flows and testing resistance, with inflows turning positive after weakness. Sustained momentum is needed for confirmation.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro:</span>
                    <br />
                    The macro environment remains mixed, with inflation contained but growth slowing, and central banks balancing dual-sided risks. Consumer weakness and global divergence remain key
                    concerns.
                  </p>
                </li>
              </ul>
              <p className="highlightedText">
                The setup reflects stabilising conditions with underlying fragility still present. As long as uncertainty continues to compress and no major negative surprises emerge, markets can
                continue to hold and grind within this range.
              </p>

              <div
                className="imageWrapperCont"
                style={{marginTop: "22px"}}
              >
                <div className="relatedImg">
                  <img
                    src={image62}
                    alt="SPX EW breakout signals breadth to rally"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image62)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image44}
                    alt="US rates still split around zero"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image44)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image114}
                    alt="a pause in a cyclical bull uptrend still in place"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image114)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1erHIjOk2Eb0e-9XsDOuKI2xjrUfI6M78VwO5-iDw-jI/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog64;
